import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Pages } from 'components/pages';
import { PermissionGuard } from 'components/permissions/components/permission-guard';
import GraphicConst from '../../graphic/graphic-const';

const GraphicsRoute: React.FC = () =>
{
  return (
    <PermissionGuard permission={GraphicConst.permissions.VIEW} fallback={<Pages.Page403 />}>
      <Routes>
        <Route path="/" element={<Pages.Graphics />} />
        <Route path="/:id/*" element={<Pages.Graphic />} />
        <Route path="/create/*" element={<Pages.Graphic />} />
      </Routes>
    </PermissionGuard>
  );
};

export default GraphicsRoute;
